import { render, staticRenderFns } from "./patientUpload.vue?vue&type=template&id=0ce52c52&"
import script from "./patientUpload.vue?vue&type=script&lang=js&"
export * from "./patientUpload.vue?vue&type=script&lang=js&"
import style0 from "./patientUpload.vue?vue&type=style&index=0&id=0ce52c52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports